<template>
  <div class="timesup-container">
    <div class="timer"><h3>0:00</h3></div>
    <div class="timesup">
        <h1>End of game {{this.$route.query.game }}!</h1>
        <router-link :to="path">
          <Button color="orange" buttonText="Next" class="button"></Button>
        </router-link>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button.vue'

export default {
  name: 'timesUp',
  components: {
    Button
  },
  data() {
    return {
      path: ''
    }
  },
  mounted() {
    this.$ga.page('/times-up')
    //eslint-disable-next-line no-console
    console.log(this.$route)
    if(this.$route.query.fromTrivia) {
      this.path = '/spot-the-not'
    } else {
      this.path = '/results'
    }
  }
}
</script>

<style scoped>
  .timesup {
    width:100%;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  h1 {
    color: #fff;
    font-size: 120px;
    font-weight: bolder;
    text-align: center;
    margin: 20px 0;
    text-transform: uppercase;
  }

  .button {
    position: relative;
    margin-top:60px;
  }

  .timer {
    background: url('../assets/timer_bg.png') top center no-repeat;
    height: 210px;
    position: absolute;
    left: 50%;
    margin-bottom: 50px;
    top: 0;
    transform: translateX(-50%);
    width:279px;
  }

  h3 {
    bottom:40px;
    color: #fff;
    font-size: 62px;
    font-weight: 900;
    left: 50%;
    margin: 0;
    position: absolute;
    transform: translateX(-50%);
  }
</style>